(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/app"],{

/***/ "./src/js/app.js"
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_toggles__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.mjs");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");




window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
var replaceMenu = function replaceMenu() {
  if ($(window).width() < mq.lg) {
    $(".js-panel").append($(".js-main-menu"));
    $(".js-panel").append($(".js-nav-bottom-menu"));
  } else {
    $(".js-header-main").prepend($(".js-main-menu "));
    $(".js-nav-bottom").prepend($(".js-nav-bottom-menu"));
    $(".js-panel").removeClass("panel-active");
    $(".js-nav-toggle").removeClass("is-active");
    $("html").removeClass("show-nav");
  }
  if ($(window).width() < mq.sm) {
    $(".js-panel").append($(".js-nav-top-menu"));
  } else {
    $(".js-nav-top-right").prepend($(".js-nav-top-menu"));
  }
};

// <div class="js-nav-bottom d-flex align-items-center gap-1">

//     <nav class="js-nav-bottom-menu nav-bottom-menu">

replaceMenu();
function headerScroll() {
  var bodyElement = $("body");
  if ($(window).scrollTop() > 31) {
    if (bodyElement.hasClass("is-scrolled")) return;
    $(bodyElement).addClass("is-scrolled");
  } else {
    if (!bodyElement.hasClass("is-scrolled")) return;
    $(bodyElement).removeClass("is-scrolled");
  }
}
headerScroll();

// Scroll events
$(window).on("scroll", function () {
  headerScroll();
});
$(window).on("resize", function () {
  replaceMenu();
});

// Site notice
function checkSiteNotice() {
  // Check the notice if it should be shown
  if (!js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].get("site-notice-hidden") || js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].get("site-notice-hidden") !== "true") {
    $(".js-sitenotice").removeClass("d-none");
  }
}

// On click js-close-notice use js-cookie to set "notice-hidden" cookie to true and hide the notice
$(document).on("click", ".js-sitenotice-close", function () {
  // Set cookie and hide notice
  js_cookie__WEBPACK_IMPORTED_MODULE_3__["default"].set("site-notice-hidden", "true", {
    expires: 1
  });
  $(".js-sitenotice").addClass("d-none");
});
checkSiteNotice();

// Selecteer alle links die een hash (#) in het href attribuut hebben
$('a[href*="#"]').on("click", function (e) {
  // Voorkom de standaard click-actie
  e.preventDefault();

  // Sla de hash (bijvoorbeeld #section) op uit het href attribuut
  var targetHash = this.hash;

  // Controleer of de hash niet leeg is
  if (targetHash) {
    // Vind het doel-element met het bijbehorende ID
    var target = $(targetHash);

    // Controleer of het doel-element bestaat
    if (target.length) {
      // Animatie van de scroll naar het doel
      $("html, body").animate({
        scrollTop: target.offset().top - 0 // 50 pixels boven het doel
      }, 1000, function () {
        // Optioneel: zet de focus op het doel-element na scrollen
        window.location.hash = targetHash;
      });
    }
  }
});
$(".js-home-news").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  centerMode: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2
    }
  }]
});
var $bundleSlider = $(".js-product-bundle-slider");
if ($bundleSlider.length && !$bundleSlider.hasClass("slick-initialized")) {
  $bundleSlider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1.5
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.2
      }
    }]
  });
}
$(".js-home-usp-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  centerMode: false,
  autoplay: true,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1
    }
  }]
});
$(".js-home-news").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  centerMode: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2
    }
  }]
});

/***/ },

/***/ "./src/js/sliders.js"
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");

$(document).ready(function () {
  // Hoofdafbeelding slider
  $(".js-product-hero-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".js-product-hero-thumbs"
  });

  // Thumbnail navigatie slider
  $(".js-product-hero-thumbs").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: ".js-product-hero-slider",
    dots: false,
    centerMode: false,
    initialSlide: 0,
    focusOnSelect: true,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 400,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  // Variatie selectie om naar de juiste afbeelding te sliden
  $("#variant-select").on("change", function () {
    // Haal de index op van de geselecteerde variatie
    var selectedIndex = $(this).find(":selected").data("variant-index");

    // Schakel de hoofdafbeelding naar de corresponderende slide
    $(".js-product-hero-slider").slick("slickGoTo", selectedIndex);
  });
});
$(".js-home-collection-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  centerMode: false,
  autoplay: true,
  prevArrow: $(".js-home-collection-slider-prev"),
  nextArrow: $(".js-home-collection-slider-next"),
  responsive: [{
    breakpoint: 1400,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1
    }
  }]
});
$(".js-reviews-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  centerMode: false,
  prevArrow: $(".js-review-slider-prev"),
  nextArrow: $(".js-review-slider-next"),
  responsive: [{
    breakpoint: 1200,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: 992,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2
    }
  }]
});
$(".js-project-slider").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  centerMode: false,
  prevArrow: $(".js-project-slider-prev"),
  nextArrow: $(".js-project-slider-next"),
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 1.2
    }
  }]
});

/***/ },

/***/ "./src/js/toggles.js"
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
$(document).on("click", ".js-nav-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(".js-searchbar").removeClass("is-active");
  $("html").toggleClass("show-nav");
});
$(document).on("click", ".js-search", function (e) {
  e.preventDefault();
  if ($(".js-nav-toggle").hasClass("is-active")) return;
  $(".js-searchbar").toggleClass("is-active");
});
$(document).on("click", ".js-minicart-toggle", function (e) {
  e.preventDefault();
  $("html").toggleClass("show-minicart");
});
$(document).on("click", ".js-minicart-close", function (e) {
  e.preventDefault();
  $("html").removeClass("show-minicart");
});
$(document).on("click", ".js-lang-toggle", function (e) {
  e.preventDefault();
  $("html").addClass("show-lang");
});
$(document).on("click", ".js-lang-close", function (e) {
  e.preventDefault();
  $("html").removeClass("show-lang");
});
$(document).on("click", ".js-footer-toggle ", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("nav").children("ul").stop().slideToggle();
});
$(document).on("click", ".js-collection-filter-toggle", function () {
  var parent = $(this).parent();
  var content = parent.find(".collection-filter-content");
  parent.toggleClass("is-hidden"); // voegt toe/verwijdert 'is-hidden'
  content.stop().slideToggle(); // toggle animatie
});

/***/ },

/***/ "./src/scss/app.scss"
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);